"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMobileActionsWrapper = exports.StyledMobileActionContent = exports.StyledMobileActionLabel = exports.StyledMobileActionItem = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../general");
const utils_1 = require("../../general/button/utils");
exports.StyledMobileActionItem = (0, styled_components_1.default)(general_1.Flexbox) `
  height: 72px;
  cursor: pointer;
  & + & {
    border-top: 1px solid ${theme_1.grayScale[200]};
  }
  ${(0, utils_1.setSVGStyles)(undefined, '16px', '16px')}
`;
exports.StyledMobileActionLabel = (0, styled_components_1.default)(general_1.Typography) `
  ${({ colorVariant }) => {
    const isPrimary = !colorVariant || colorVariant === 'primary';
    return (0, styled_components_1.css) `
      text-transform: uppercase;
      color: ${isPrimary ? theme_1.primary.main : theme_1.secondary.main};
      &:hover {
        color: ${isPrimary ? theme_1.primary.dark : theme_1.secondary.dark};
      }
    `;
}}
`;
exports.StyledMobileActionContent = (0, styled_components_1.default)(general_1.Flexbox) `
  ${({ hasSidebar }) => {
    return (0, styled_components_1.css) `
      background-color: blue;
      overflow: hidden;
      transition: all 0.4s ease-in-out;
      width: 100vw;
      max-height: 0;
      background-color: white;
      box-shadow: ${theme_1.shadows.hover};
      transform: translateY(100%);
      & + & {
        border-top: 1px solid ${theme_1.grayScale[200]};
      }

      &:before {
        content: '';
        position: absolute;
        top: 8px;
        left: 50%;
        transform: translateX(-50%);
        height: 4px;
        width: 40px;
        border-radius: 2px;
        background-color: ${theme_1.grayScale[300]};
      }
      ${!hasSidebar &&
        (0, styled_components_1.css) `
        &:after {
          content: '';
          position: absolute;
          bottom: 8px;
          left: 50%;
          transform: translateX(-50%);
          height: 5px;
          width: 135px;
          border-radius: 8px;
          background-color: ${theme_1.grayScale[900]};
        }
      `}
    `;
}}
`;
exports.StyledMobileActionsWrapper = (0, styled_components_1.default)(general_1.Flexbox) `
  ${props => {
    const { customStyles, isOpen, hasSidebar, showFilterButton } = props;
    return (0, styled_components_1.css) `
      z-index: 500;
      display: block;
      position: fixed;
      bottom: ${hasSidebar ? (isOpen ? '109px' : '125px') : isOpen ? '0' : '20px'};
      right: 0;
      transition: all 0.4s ease-in-out;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        width: 0 !important;
      }

      ${exports.StyledMobileActionContent} {
        padding: ${hasSidebar ? '17px 0 0' : '17px 0'};
      }

      ${exports.StyledMobileActionItem} {
        color: ${theme_1.primary.main};
        &:last-child {
          background-color: ${showFilterButton ? '#F0F7FB' : 'none'};
        }
      }

      ${isOpen &&
        (0, styled_components_1.css) `
        ${exports.StyledMobileActionContent} {
          transform: translateY(0);
          max-height: 500px;
        }
      `}

      ${customStyles || {}};
    `;
}}
`;
//# sourceMappingURL=styles.js.map